import { expressQuerySelector, expressQuerySelectorAll, htmlToElement, expressAddClass } from "../../common/html";
import { IInlineEditCardComponent, initializeInlineEditCard } from "./inline-edit-card";
import { initializeInlineEditPopupAsync } from "./inline-edit-details";

export function initializeInlineEditHtml(container: HTMLElement | Element | Document | DocumentFragment) {
	const inlineEditEls = expressQuerySelectorAll<HTMLElement>(
		container,
		"[data-inlineedit-pageid][data-inlineedit-contentkeyname][data-inlineedit-fieldname]",
	);
	if (inlineEditEls?.length == 0) return;

	inlineEditEls.forEach((inlineEditEl) => {
		const parent = inlineEditEl.parentNode;
		const wrapper = document.createElement("div");
		expressAddClass(wrapper, "t-inline-editing-zone");

		parent.replaceChild(wrapper, inlineEditEl); // add wrapper to the parent
		wrapper.appendChild(inlineEditEl); // add element to the wrapper

		// add extra html to the wrapper
		wrapper.appendChild(
			htmlToElement(
				"<div class='t-inline-editing-zone__edit'> " +
					"<span class='v2-a-icon v2-a-icon--small technial-inlineediting-editicon'> " +
					"<i class='v2-a-icon__icon'" +
					"title='" +
					inlineEditEl.dataset.inlineeditContentkeyname +
					"&#013;" +
					inlineEditEl.dataset.inlineeditFieldname +
					"'> " +
					"<svg class='v2-a-icon__svg'> " +
					"<use class='v2-a-icon__use' href='/svg/pencil-symbol.svg#pencil-symbol'> " +
					"</use>" +
					"</svg>" +
					"</i>" +
					"</span>" +
					"</div>",
			),
		);

		const iconEl = expressQuerySelector(wrapper, ".technial-inlineediting-editicon", true);
		iconEl.addEventListener("click", async (el) => {
			el.preventDefault();
			el.stopImmediatePropagation();

			const popup = await initializeInlineEditPopupAsync(inlineEditEl);
			await popup.openAsync();
		});
	});
}

export function initInlineEdit(): IInlineEditCardComponent {
	const inlineEditCard = initializeInlineEditCard();
	initializeInlineEditHtml(document);

	return {
		dispose: inlineEditCard?.dispose,
	};
}
